import { IOption } from '../components/QuestionForm';
export interface IQuestion {
    title: string;
    options: IOption[];
}

const question = {
    title: 'How long have you been operating your business?',
    options: [
        { label: 'Just starting', value: 'option1' },
        { label: 'Less than year', value: 'option2' },
        { label: '1-2 years', value: 'option3' },
        { label: '2-5 years', value: 'option4' },
        { label: '5-10 years', value: 'option5' },
        { label: '10+ years', value: 'option6' },
    ],
};

const question2 = {
    title: 'How many bookings do you expect per month?',
    options: [
        { label: 'Less than 30', value: 'option1' },
        { label: '30-200', value: 'option2' },
        { label: '200-500', value: 'option3' },
        { label: 'More than 500', value: 'option4' },
    ],
};

const question3 = {
    title: 'Which best descibes your business?',
    options: [
        { label: 'Tour', value: 'option1' },
        { label: 'Activity or experience', value: 'option2' },
        { label: 'Attraction', value: 'option3' },
        { label: 'Shuttle', value: 'option4' },
        { label: 'Multi-day tour', value: 'option5' },
        { label: 'Event ', value: 'option6' },
        { label: 'Rental ', value: 'option7' },
        { label: 'Accommodation ', value: 'option8' },
        { label: 'Other ', value: 'option9' },
    ],
};

const question4 = {
    title: 'Which best describes your business?',
    options: [
        { label: 'Global online travel agency', value: 'option1' },
        { label: '	Regional online travel agency', value: 'option2' },
        { label: 'Destination marketing organisation', value: 'option3' },
        { label: 'High Street travel agency', value: 'option4' },
        { label: 'Concierge desk', value: 'option5' },
        { label: 'Wholesaler', value: 'option6' },
        // { label: 'Visitor or information cente', value: 'option7' },
        // { label: 'Operator looking to sell other operators tours, activities or attractions', value: 'option8' },
        // { label: 'Other', value: 'option9' },
    ],
};

export const operators = [question, question2, question3];
export const resellers = [question, question2, question4];
